import { Button } from "@/pages/newHome/ui/button";
// import { Card, CardContent } from "@/pages/newHome/ui/card";
// import maskGroup11 from "@/assets/newHome/03@3x.webp";
import maskGroup11 from "@/assets/newHome/04@3x.webp";
// import ScheduleDemo from "@/features/onboarding/login/Schedule-demo";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "@/store";

export const CtaByAnima = (): JSX.Element => {
  const navigate = useNavigate();
      // const [isLoggedIn, setIsLoggedIn] = useState<boolean | null>(null);
      const user = useSelector(
        (state: RootState) => state.rootReducer.userReducer.user
      );
  return (
    <section className="w-full bg-gradient-to-b from-white to-[#eefff2] px-4 py-8 sm:px-6 sm:py-14 md:px-14 md:py-20 pointer-events-auto">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center gap-10 lg:gap-16">
        {/* Text Content */}
        <div className="flex-1 space-y-6 max-w-[603px] text-left">
          <h2 className="text-2xl sm:text-3xl md:text-[20px] lg:text-[40px] font-semibold text-charcol leading-tight lg:leading-[56px] tracking-tight">
            Ready to take your business
            <span className="inline sm:hidden">&nbsp;</span>
            <br className="hidden sm:block" />
            to the next level?
          </h2>

          <p className="text-base sm:text-lg md:text-[14px] lg:text-[22px] text-charcoal leading-relaxed lg:leading-[35px]">
            Getting started is simple. Get access and see how BuildMapper fits
            your sales workflow. No pressure — just a smarter way to grow.
          </p>

          <div className="flex justify-start">
            {/* <ScheduleDemo>
            <Button className="px-6 h-[50px] sm:px-8 py-3 sm:py-4 rounded-full bg-primary hover:bg-[#239e41] text-white text-lg sm:text-xl">
              Get Started
            </Button>
            </ScheduleDemo> */}
            <Button
              onClick={(e) => {
                if (user) {
                  e.preventDefault();
                  navigate("/dashboard/explore_leads");
                } else {
                  // window.open("https://buildmapper.typeform.com/to/oVrzJex7", "_blank");
                  //  window.open(`${window.location.origin}/newOnboarding`, "_self");
                  navigate("auth/signup")
                }
              }}
              className="sm:w-40 h-[50px] rounded-[40px] bg-primary hover:bg-[#239e41] shadow-none text-[16px] md:text-lg sm:text-xl font-medium text-white"
            >
              Get Started
            </Button>
          </div>
        </div>

        {/* Image Card */}
        <div className="flex-1 ml-16 sm:ml-0 w-[116%] lg:w-[70%] md:w-[85%] sm:w-[55%]">
          {/* <Card
            className="w-full aspect-video bg-gray-100/60 rounded-lg backdrop-blur-[22px] border-0"
            style={{
              backgroundImage: `url(${maskGroup11})`,
              backgroundSize: "contain",
              backgroundPosition: "bottom",
              backgroundRepeat: "no-repeat",
            }}
          > */}
          <img src={maskGroup11} alt="" />
            {/* Window Controls */}
            {/* <div className="h-5 bg-gray-200/60 backdrop-blur-[22px] rounded-t-lg flex items-center pl-4 space-x-2">
              <div className="w-2 h-2 rounded-full bg-[#ee6666]"></div>
              <div className="w-2 h-2 rounded-full bg-[#f6c566]"></div>
              <div className="w-2 h-2 rounded-full bg-[#5bea7a]"></div>
            </div>
            <CardContent />
          </Card> */}
        </div>
      </div>
    </section>
  );
};
